/*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  onlineCOCOverviewAriaLabel: {
    id: 'OnlineCOCOverview_OnlineCOCOverviewAriaLabel',
    defaultMessage: 'Report Changes',
  },
  onlineCOCOverviewPageTitle: {
    id: 'OnlineCOCOverview_PageTitle',
    defaultMessage: 'Report Changes',
  },
  overviewTitle: {
    id: 'OnlineCOCOverview_LabelOverviewTitle',
    defaultMessage: 'Overview',
  },
  overviewDescriptionSubtitle: {
    id: 'OnlineCOCOverview_LabelDescriptionSubtitle',
    defaultMessage: 'Here you can report changes. If you are the primary member on this case, you can report changes for other household member(s).',
  },
  overviewHeading: {
    id: 'OnlineCOCOverview_LabelOverviewHeading',
    defaultMessage: 'Economic Assistance Benefits',
  },
  stepOneHeading: {
    id: 'OnlineCOCOverview_LabelStepOneHeading',
    defaultMessage: 'Prepare',
  },
  stepOneDescription_1: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_1',
    defaultMessage: "You will be asked to review the information we have on this case. Type of changes that can be reviewed and reported on:",
  },
  stepOneDescription_2: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_2',
    defaultMessage: 'Household details: name, SSN, citizenship status',
  },
  stepOneDescription_3: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_3',
    defaultMessage: 'General information: disability, pregnancy, foster care,  etc.',
  },
  stepOneDescription_4: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_4',
    defaultMessage: 'Income: employment, self-employment, benefits',
  },
  stepOneDescription_5: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_5',
    defaultMessage: 'Benefits: AABD, Medicare Part A, B, C or D, Refugee Cash Assistance, etc.',
  },
  stepOneDescription_6: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_6',
    defaultMessage: 'Resources: bank accounts, vehicles',
  },
  stepOneDescription_7: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_7',
    defaultMessage: 'Expenses: medical expenses, child support expenses',
  },
  stepOneDescription_8: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_8',
    defaultMessage: 'Health Insurance',
  },
  stepOneDescription_9: {
    id: 'OnlineCOCOverview_LabelStepOneDescription_9',
    defaultMessage: 'Child Care Provider',
  },
  stepTwoHeading: {
    id: 'OnlineCOCOverview_LabelStepTwoHeading',
    defaultMessage: 'Report your change',
  },
  stepTwoDescription_1: {
    id: 'OnlineCOCOverview_LabelStepTwoDescription_1',
    defaultMessage: "It's important we have the latest information so everyone in the household receives the assistance for which they might be eligible. Complete this form to report changes.",
  },
  stepTwoDescription_2: {
    id: 'OnlineCOCOverview_LabelStepTwoDescription_2',
    defaultMessage: "After submitting your reported change, you will get a confirmation message. You will receive a separate notice stating any documents that may be required to verify the updates you have provided. You can upload these documents from the  Documents page.",
  },
  stepThreeHeading: {
    id: 'OnlineCOCOverview_LabelStepThreeHeading',
    defaultMessage: 'Decision',
  },
  stepThreeDescription_1: {
    id: 'OnlineCOCOverview_LabelStepThreeDescription_1',
    defaultMessage: "Once we've processed your documents, you will receive a notice if there are any changes to your benefits.",
  },
  stepThreeAlert: {
    id: 'OnlineCOCOverview_LabelStepThreeAlert',
    defaultMessage:
      "Don't worry if you don't have them to hand, you have up to 30 days to submit them after we receive your application.",
  },
  finalInfoOne: {
    id: 'OnlineCOCOverview_LabelFinalInfo',
    defaultMessage: 'You can save your application, and come back later to finish filling it out.',
  },
  finalInfoTwo: {
    id: 'OnlineCOCOverview_finalInfoTwo',
    defaultMessage: '{loginLink} or {signupLink} to save your application progress.',
  },
  finalInfoTwoLoginLink: {
    id: 'OnlineCOCOverview_finalInfoTwoLoginLink',
    defaultMessage: 'Log in',
  },
  finalInfoTwoSignupLink: {
    id: 'OnlineCOCOverview_finalInfoTwoSignupLink',
    defaultMessage: 'sign up',
  },
  startButton: {
    id: 'OnlineCOCOverview_LabelStartButton',
    defaultMessage: 'Start',
  },
  applyForBenefitsLink: {
    id: 'OnlineCOCOverview_BackLink',
    defaultMessage: 'Back',
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program',
  },
});
